import { useI18n } from '@/hooks/useI18n';
import { ArrowDown, ArrowUp, Minus } from 'lucide-react';
import { cn } from '@/lib/cn';
import { formatPct, formatNumber } from '@/lib/format';

interface DeltaProps {
  value: number | null | undefined;
  format?: 'pct' | 'number';
  className?: string;
}

export function Delta({ value, format = 'pct', className }: DeltaProps) {
  useI18n();
  if (value === null || value === undefined || Number.isNaN(value)) {
    return <span className={cn('font-mono text-[11px] text-text-4', className)}>—</span>;
  }
  const positive = value > 0;
  const negative = value < 0;
  const Icon = positive ? ArrowUp : negative ? ArrowDown : Minus;
  const tone = positive ? 'text-emerald' : negative ? 'text-rose' : 'text-text-3';
  const display =
    format === 'pct' ? formatPct(value) : `${value > 0 ? '+' : ''}${formatNumber(value)}`;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 text-[12px] font-medium tabular-nums',
        tone,
        className,
      )}
    >
      <Icon className="h-3 w-3" />
      {display}
    </span>
  );
}
